/** Stands in for our own origin when resolving a relative link. */
const SAME_SITE = "https://same-site.invalid"

/**
 * Whether a link from content is safe to navigate to: a web page, here or
 * elsewhere. Anything else, `javascript:` above all, would run in the
 * visitor's session on our origin. The link is resolved the way the browser
 * will resolve it, so relative and protocol-relative forms count as web pages.
 */
export function isNavigableLink(link: string): boolean {
  try {
    const { protocol } = new URL(link, SAME_SITE)
    return protocol === "https:" || protocol === "http:"
  } catch {
    return false
  }
}
